export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿澈",
    role: "热血漫画控",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20young%20asian%20man%20profile%20portrait%20avatar%20illustration%2C%20warm%20smile%2C%20flat%20modern%20illustration%20style%2C%20warm%20neutral%20background&width=200&height=200&seq=avatar-01&orientation=squarish",
    content: "叮咚漫画网的新作更新是真的快，很多想看的番都是这里先上，独家抢先看简直太爽了，我已经安利给整个追更群了。",
  },
  {
    name: "糯米团子",
    role: "恋爱治愈系读者",
    avatar: "https://readdy.ai/api/search-image?query=gentle%20young%20asian%20woman%20profile%20portrait%20avatar%20illustration%2C%20soft%20smile%2C%20flat%20modern%20illustration%20style%2C%20soft%20warm%20background&width=200&height=200&seq=avatar-02&orientation=squarish",
    content: "画风筛选做得太贴心了，想看的治愈系和恋爱番一目了然，每天的新番速递让我永远不会错过好作品，强烈推荐。",
  },
  {
    name: "刀客张三",
    role: "玄幻仙侠读者",
    avatar: "https://readdy.ai/api/search-image?query=mature%20asian%20man%20profile%20portrait%20avatar%20illustration%20with%20light%20beard%2C%20confident%20look%2C%20flat%20modern%20illustration%20style%2C%20warm%20neutral%20background&width=200&height=200&seq=avatar-03&orientation=squarish",
    content: "从剑仙风云录入坑，独家内容品质在线、更新稳定，评论区氛围也特别好，是真正懂漫画读者的平台。",
  },
  {
    name: "小满",
    role: "校园青春读者",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20girl%20profile%20portrait%20avatar%20illustration%20with%20glasses%2C%20bright%20smile%2C%20flat%20modern%20illustration%20style%2C%20soft%20cream%20background&width=200&height=200&seq=avatar-04&orientation=squarish",
    content: "榜单和编辑推荐每次都很准，跟着叮咚追番基本不踩雷，新番上架速递这个板块我每天都刷，太上头了。",
  },
];